import i18n from "@/i18n";

export const selectInstancesFields = [
    {
        key: "name",
        label: i18n.t("instanceGroups.name"),
        tdClass: "text-left",
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "versionNumber",
        label: i18n.t("instances.version")
    }
];
